import { render, staticRenderFns } from "./inflections-subtables-wide.vue?vue&type=template&id=90e0d7c6&"
import script from "./inflections-subtables-wide.vue?vue&type=script&lang=js&"
export * from "./inflections-subtables-wide.vue?vue&type=script&lang=js&"
import style0 from "./inflections-subtables-wide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90e0d7c6')) {
      api.createRecord('90e0d7c6', component.options)
    } else {
      api.reload('90e0d7c6', component.options)
    }
    module.hot.accept("./inflections-subtables-wide.vue?vue&type=template&id=90e0d7c6&", function () {
      api.rerender('90e0d7c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/inflections/inflections-subtables-wide.vue"
export default component.exports